module.exports = __webpack_public_path__ + "images/niabtag_faa813ba07b7a2080a0ba4ca6f6b62e8.png";